import React, { useEffect, useState } from "react";
import {
  Route,
  Routes,
  useLocation,
  useParams,
  useSearchParams,
} from "react-router-dom";
import "./Dashboard.scss";
import MenuBar from "../../components/Menu/MenuBar";
import Footer from "../../components/Footer/Footer";
import {
  Col,
  Layout,
  Pagination,
  Row,
  theme,
  notification,
  Grid,
  Carousel,
  Skeleton,
  Image,
  Button,
  Flex,
} from "antd";
import Capacities from "../Capacities/capacities";
import EntityDetail from "../Entities/Entities-Detail";
import CapacityDetail from "../Capacities/Capacities-Detail";
import Entities from "../Entities/entities";
import GroupDetail from "../Groups/group_detail";
import CompaniesDetail from "../Companies/companies";
import Title from "antd/es/typography/Title";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import { ContentHeaderDetailed } from "../../components/ContentHeader/ContentHeader";
import SearcherDetail from "../Searchers/searcher_detail";
import SearchEntityForm from "../../components/Forms/SearchEntitiesForm";
import SearchCapacityForm from "../../components/Forms/SearchCapacitiesForm";
import useSearch from "../../../hooks/entities-hook";
import {
  Actor,
  Capacity,
  CommonCapacities,
  Props,
  PageSetting,
  ImportMessages,
  Query,
  Events,
} from "../../index";
import { useSearchCapacities } from "../../../hooks/capacities-hook";
import ProductDetail from "../Products/Product-Detail";
import CommonsDetail from "../Commons/commons";
import { useSelector } from "react-redux";
import { Adapter } from "../../../shared/adapter";
import { HeaderAdapter } from "../../../adapter/header-adapter";
import UniversitiesDetail from "../Universities/universities";
import store from "../../../controllers/store";
import { executeimportDefault } from "../../../controllers/store/actions/import/execute-import-actions";
import useEventsSearch from "../../../hooks/events-hook";
import { CalendarOutlined, MoreOutlined } from "@ant-design/icons";
import { getActorTypes } from "../../../controllers/entities";
import { getCapacitiesType } from "../../../controllers/capacities";

const { Header, Content } = Layout;

let queryEntities: Query = {
  filter: {} as any,
};

let queryCapacities: Query = {
  filter: {} as any,
};
const dispatch = store.dispatch;
const { useBreakpoint } = Grid;
const Dashboard = (Props: Props) => {
  const screens = useBreakpoint();
  const [searchParams] = useSearchParams();
  const [api, contextHolder] = notification.useNotification();
  const { result: resultCapacities, searchCapacities } = useSearchCapacities();
  const { result: events_result, searchEvents } = useEventsSearch();
  const { result, searchEntities } = useSearch();
  const [forceRemount, setForceRemount] = useState(false);
  const [actorTypes, setActortypes] = useState([]);
  const [capacities, setCapacitiesTypes] = useState([]);
  const [loading, setLoading] = useState<Boolean>(result?.loading || false);
  const location = useLocation();
  const [actor, setActor] = useState({} as any);
  const [capacity, setCapacity] = useState({} as any);
  const [initialDataCapacities, setInitialDataCapacities] = useState<
    CommonCapacities[]
  >([]);
  const [page, setpage] = useState<number>(0);
  const [total, setTotal] = useState<number>(0);
  const [pageCapacity, setpageCapacity] = useState<number>(0);
  const executeImportState = useSelector((state: any) => {
    return state.executeImport;
  });

  const actorType = searchParams.get("actortype") || "";
  const capacityType = searchParams.get("capacitytype") || "";

  const commonsCapacityType = searchParams.get("commonscapacitytype") || "";
  const commonsType = searchParams.get("commonstype") || "";

  useEffect(() => {
    if (location.pathname === "/capacities") {
      console.log("on location  capacities");
      searchCapacities("all", { filter: "" }, 1, PageSetting.limit);
    }
  }, [location]);

  useEffect(() => {
    if (actorType) {
      searchEntities(actorType || "all", { filter: "" }, 1, PageSetting.limit);
    }

    if (commonsType) {
      searchEntities(
        "commons",
        { filter: `&filter[actor_type][_eq]=${commonsType}` },
        1,
        PageSetting.limit
      );
    }

    if (capacityType) {
      searchCapacities(
        capacityType || "all",
        { filter: "" },
        1,
        PageSetting.limit
      );
    }

    if (commonsCapacityType) {
      searchCapacities(
        "commons_capacities",
        { filter: `&filter[capacity_type][_eq]=${commonsCapacityType}` },
        1,
        PageSetting.limit
      );
    }

    const getActors = async () => {
      const actors = await getActorTypes();
      setActortypes(actors);
    };
    const get_capacities_types = async () => {
      const capacitiesData = await getCapacitiesType();
      setCapacitiesTypes(capacitiesData);
    };

    get_capacities_types();
    getActors();
  }, [actorType, commonsType, commonsCapacityType, capacityType]);

  useEffect(() => {
    if (!actorType && !capacityType && !commonsType && !commonsCapacityType) {
      searchEntities("all", { filter: "" }, 1, PageSetting.limit);
    }
  }, []);

  useEffect(() => {
    searchEvents(
      "events",
      {
        filter: `&filter[visibility_end_date][_gt]=${new Date().toISOString()}&filter[status][_eq]=Published`,
      },
      1,
      PageSetting.limit
    );
  }, []);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const showImportMessageSuccess = () => {
    api["success"]({
      key: 1,
      message: ImportMessages.Title,
      description: ImportMessages.ImportSuccessMessage,
    });
    dispatch(executeimportDefault());
    return null;
  };

  return (
    <div
      className="animate__animated animate__fadeIn"
      style={{ height: "100vh" }}
    >
      {contextHolder}
      {executeImportState.result ? showImportMessageSuccess() : null}
      <Layout>
        {location?.state ? (
          <>
            <MenuBar />
            <Breadcrumbs
              title={
                location.pathname.includes("entities") ||
                location.pathname.includes("searchers") ||
                location.pathname.includes("groups") ||
                location.pathname.includes("universities")
                  ? "Entidades"
                  : "Capacidad"
              }
              data={Adapter.from([location.state]).to((values) =>
                new HeaderAdapter(values).adapt()
              )}
            />
            <ContentHeaderDetailed
              title={
                location.pathname.includes("entities") ||
                location.pathname.includes("searchers") ||
                location.pathname.includes("groups") ||
                location.pathname.includes("universities")
                  ? "Entidades"
                  : "Capacidad"
              }
              values={Adapter.from([location.state]).to((values) =>
                new HeaderAdapter(values).adapt()
              )}
            />
          </>
        ) : (
          <>
            <MenuBar />
            <Skeleton
              loading={events_result.loading}
              active
              className="full-width"
            >
              {/* Carousel */}

              {events_result.values.length > 0 ? (
                <>
                  <Carousel autoplay>
                    {events_result.values.map((event: Events) => (
                      <div>
                        <Image
                          onClick={() => {
                            if (event.url) {
                              window.open(event.url, "_blank");
                            }
                          }}
                          src={event.banner}
                          alt={event.name}
                          width="100%"
                          height={450}
                          style={{ objectFit: "cover" }}
                          preview={false}
                        />
                      </div>
                    ))}
                  </Carousel>
                  <br />
                  <Flex gap="small" justify="center" vertical>
                    <Flex gap="small" justify="center">
                      <Button
                        loading={events_result.loading}
                        onClick={() => {
                          window.location.href = "/events-listing";
                        }}
                        type="primary"
                        shape="round"
                        icon={<CalendarOutlined />}
                        size={"large"}
                      >
                        Mas eventos...
                      </Button>
                    </Flex>
                  </Flex>
                  <br />
                </>
              ) : null}
            </Skeleton>
            <Header className="bg-header">
              <div className={screens.lg ? "form-search" : "form-search-movil"}>
                {screens.lg || screens.xs || screens.sm ? (
                  <>
                    {location.pathname === "/entities" ? (
                      <>
                        <Title
                          className={
                            screens.xs
                              ? "font-size-22 header-title"
                              : "header-title"
                          }
                        >
                          ¡Creando oportunidades de colaboración e innovación!
                        </Title>
                        <Title level={5} className="header-subtitle">
                          Descubre las entidades proveedoras que tenemos
                          disponibles para potenciar la colaboración, la
                          innovación y establecer conexiones con otros actores
                          que tengan tus mismos intereses.
                        </Title>
                      </>
                    ) : (
                      <>
                        <Title className="header-title">
                          ¡Creando oportunidades de colaboración e innovación!
                        </Title>
                        <Title level={5} className="header-subtitle">
                          Explora nuestra lista de diversas capacidades en
                          diferentes áreas disponibles en Conection Santander,
                          tanto si eres un consumidor como un proveedor de
                          conocimiento. Registra tus habilidades y conecta con
                          otras organizaciones para colaborar en iniciativas
                          conjuntas, buscar financiamiento o desarrollar
                          proyectos de colaboración.
                        </Title>
                      </>
                    )}
                  </>
                ) : null}
                {location.pathname === "/capacities" ? (
                  <SearchCapacityForm
                    onSearchChangeValue={(value: string) => {
                      console.log("producto", value);
                      if (!value) {
                        delete queryCapacities.filter.text;
                      } else {
                        queryCapacities.filter.text = `&text=${value}&`;
                      }
                    }}
                    onSelectKnowledgeArea={async (selected: any) => {
                      setLoading(true);
                      if (!selected) {
                        delete queryCapacities.filter.KnowledgeArea;
                      } else {
                        queryCapacities.filter.KnowledgeArea = `&filter[area_de_conocimiento][id][_eq]=${selected.value}`;
                      }
                      searchCapacities(
                        capacity.collectionName,
                        queryCapacities,
                        1,
                        PageSetting.limit
                      );
                      setTotal(
                        resultCapacities.pagination?.total || PageSetting.limit
                      );
                      setpage(1);
                      setLoading(false);
                    }}
                    onSelectKnowledgeGran={async (selected: any) => {
                      setLoading(true);

                      if (!selected) {
                        delete queryCapacities.filter.KnowledgeGran;
                      } else {
                        queryCapacities.filter.KnowledgeGran = `&filter[gran_area_de_conocimiento][id][_eq]=${selected.value}`;
                      }

                      searchCapacities(
                        capacity.collectionName,
                        queryCapacities,
                        1,
                        PageSetting.limit
                      );
                      setTotal(
                        resultCapacities.pagination?.total || PageSetting.limit
                      );
                      setpage(1);
                      setLoading(false);
                    }}
                    onSearchPressEnter={async (value: any) => {
                      setLoading(true);

                      if (!value) {
                        delete queryCapacities.filter.text;
                      } else {
                        queryCapacities.filter.text = `&text=${value}&`;
                      }

                      searchCapacities(
                        capacity.collectionName,
                        queryCapacities,
                        1,
                        PageSetting.limit
                      );
                      setTotal(result?.pagination?.total || PageSetting.limit);
                      setLoading(result?.loading || false);
                      setpage(0);
                    }}
                    onSearchChange={async (selected: any) => {
                      setLoading(true);

                      if (!selected) {
                        delete queryCapacities.filter.text;
                      } else {
                        queryCapacities.filter.text = `&text=${selected}&`;
                      }

                      searchCapacities(
                        capacity.collectionName,
                        queryCapacities,
                        1,
                        PageSetting.limit
                      );
                      setTotal(
                        resultCapacities.pagination?.total || PageSetting.limit
                      );
                      setpage(1);
                      setLoading(false);
                    }}
                    onSelectCapacitiesTypeChange={async (selected: any) => {
                      setLoading(true);
                      if (!selected) {
                        delete queryCapacities.filter.capacity;
                      } else {
                        queryCapacities.filter.capacity = `&filter[capacity_type][id][_eq]=${selected.value}`;
                        queryCapacities.filter.capacity = `&filter[capacity_type][id][_eq]=${selected.value}`;
                      }

                      setInitialDataCapacities([]);
                      setCapacity(selected);
                      if (selected.collectionName === Capacity.Products) {
                        queryCapacities.filter.capacity = `&filter[capacity_type][id][_eq]=${selected.value}`;
                        searchCapacities(
                          selected.collectionName,
                          queryCapacities,
                          1,
                          PageSetting.limit
                        );
                        setTotal(
                          resultCapacities.pagination?.total ||
                            PageSetting.limit
                        );
                        setpage(1);
                        setLoading(false);

                        return;
                      }

                      if (selected.collectionName === Capacity.Projects) {
                        queryCapacities.filter.capacity = `&filter[capacity_type][id][_eq]=${selected.value}`;
                        searchCapacities(
                          selected.collectionName,
                          queryCapacities,
                          1,
                          PageSetting.limit
                        );
                        setTotal(
                          resultCapacities.pagination?.total ||
                            PageSetting.limit
                        );
                        setpage(1);
                        setLoading(false);

                        return;
                      }

                      if (
                        selected.collectionName === Capacity.CommonsCapacity
                      ) {
                        queryCapacities.filter.capacity = `&filter[capacity_type][id][_eq]=${selected.value}`;
                        searchCapacities(
                          selected.collectionName,
                          queryCapacities,
                          1,
                          PageSetting.limit
                        );
                        setTotal(
                          resultCapacities.pagination?.total ||
                            PageSetting.limit
                        );
                        setpage(1);
                        setLoading(false);

                        return;
                      }
                    }}
                    onSelectKnowledgeSpecialty={async (selected: any) => {
                      setLoading(true);

                      if (!selected) {
                        delete queryCapacities.filter.KnowledgeSpecialty;
                      } else {
                        queryCapacities.filter.KnowledgeSpecialty = `&filter[especialidad_de_conocimiento][id][_eq]=${selected.value}`;
                      }

                      searchCapacities(
                        capacity.collectionName,
                        queryCapacities,
                        1,
                        PageSetting.limit
                      );
                      setTotal(
                        resultCapacities.pagination?.total || PageSetting.limit
                      );
                      setpage(1);
                      setLoading(false);
                      return;
                    }}
                    onClearCapacityType={() => {
                      setLoading(true);
                      delete queryCapacities.filter.capacity;
                      searchEntities(
                        "all",
                        queryCapacities,
                        1,
                        PageSetting.limit
                      );
                      setTotal(result?.pagination?.total || PageSetting.limit);
                      setLoading(result?.loading || false);
                    }}
                    onClearKnowledgeArea={() => {
                      setLoading(true);
                      delete queryCapacities.filter.knowledgeArea;
                      searchEntities(
                        "all",
                        queryCapacities,
                        1,
                        PageSetting.limit
                      );
                      setTotal(result?.pagination?.total || PageSetting.limit);
                      setLoading(result?.loading || false);
                    }}
                    onClearKnowledgeGran={() => {
                      setLoading(true);
                      delete queryCapacities.filter.knowledgeGran;
                      searchEntities(
                        "all",
                        queryCapacities,
                        1,
                        PageSetting.limit
                      );
                      setTotal(result?.pagination?.total || PageSetting.limit);
                      setLoading(result?.loading || false);
                    }}
                    onClearKnowledgeSpecialty={() => {
                      setLoading(true);
                      delete queryCapacities.filter.KnowledgeSpecialty;
                      searchEntities(
                        "all",
                        queryCapacities,
                        1,
                        PageSetting.limit
                      );
                      setTotal(result?.pagination?.total || PageSetting.limit);
                      setLoading(result?.loading || false);
                    }}
                  />
                ) : (
                  <SearchEntityForm
                    onSearchChangeValue={(value: string) => {
                      if (!value) {
                        delete queryEntities.filter.text;
                      } else {
                        queryEntities.filter.text = `&text=${value}&`;
                      }
                    }}
                    onSearchPressEnter={async (value: string) => {
                      setLoading(true);

                      if (!value) {
                        delete queryEntities.filter.text;
                      } else {
                        queryEntities.filter.text = `&text=${value}&`;
                      }

                      searchEntities(
                        "all",
                        queryEntities,
                        1,
                        PageSetting.limit
                      );
                      setTotal(result?.pagination?.total || PageSetting.limit);
                      setLoading(result?.loading || false);
                      setpage(0);
                    }}
                    onSearch={async (value: string) => {
                      setLoading(true);

                      if (!value) {
                        delete queryEntities.filter.text;
                      } else {
                        queryEntities.filter.text = `&text=${value}&`;
                      }

                      searchEntities(
                        "all",
                        queryEntities,
                        1,
                        PageSetting.limit
                      );
                      setTotal(result?.pagination?.total || PageSetting.limit);
                      setLoading(result?.loading || false);
                      setpage(0);
                    }}
                    onSelectActorChange={async (selected: any) => {
                      console.log("selected actor", selected);

                      setLoading(true);
                      setActor(selected);

                      if (selected.collectionName === Actor.Company) {
                        queryEntities.filter.actor = `&filter[actor_type][id][_eq]=${selected.value}&meta=total_count`;
                        searchEntities(
                          selected.collectionName,
                          queryEntities,
                          1,
                          PageSetting.limit
                        );
                        setTotal(
                          result?.pagination?.total || PageSetting.limit
                        );
                        setpage(1);
                        setLoading(result?.loading || false);
                        return;
                      } else {
                        delete queryEntities.filter.commercial_activity;
                      }

                      if (selected.collectionName === Actor.University) {
                        queryEntities.filter.actor = `&filter[actor_type][id][_eq]=${selected.value}&`;
                        searchEntities(
                          selected.collectionName,
                          queryEntities,
                          1,
                          PageSetting.limit
                        );
                        setTotal(
                          result?.pagination?.total || PageSetting.limit
                        );
                        setLoading(result?.loading || false);
                        return;
                      }

                      if (
                        selected.collectionName === Actor.ProminentResearcher
                      ) {
                        queryEntities.filter.actor = `&filter[actor_type][id][_eq]=${selected.value}&`;
                        searchEntities(
                          selected.collectionName,
                          queryEntities,
                          1,
                          PageSetting.limit
                        );
                        setTotal(
                          result?.pagination?.total || PageSetting.limit
                        );
                        setpage(1);
                        setLoading(result?.loading || false);
                        return;
                      }

                      if (selected.collectionName === Actor.ResearchGroup) {
                        queryEntities.filter.actor = `&filter[actor_type][id][_eq]=${selected.value}`;
                        searchEntities(
                          selected.collectionName,
                          queryEntities,
                          1,
                          PageSetting.limit
                        );
                        setTotal(
                          result?.pagination?.total || PageSetting.limit
                        );
                        setpage(1);
                        setLoading(result?.loading || false);
                        return;
                      }

                      if (selected.collectionName === Actor.Commons) {
                        queryEntities.filter.actor = `&filter[actor_type][id][_eq]=${selected.value}`;
                        searchEntities(
                          selected.collectionName,
                          queryEntities,
                          1,
                          PageSetting.limit
                        );
                        setTotal(
                          result?.pagination?.total || PageSetting.limit
                        );
                        setpage(1);
                        setLoading(result?.loading || false);
                        return;
                      }
                    }}
                    onSelectCommercialActivityTypeChange={async (
                      selected: any
                    ) => {
                      setLoading(true);
                      if (!selected) {
                        delete queryEntities.filter.commercial_activity;
                      } else {
                        queryEntities.filter.commercial_activity = `&filter[ciiu][comercial_activity_id][_eq]=${selected.value}&`;
                      }

                      searchEntities(
                        actor.collectionName,
                        queryEntities,
                        1,
                        PageSetting.limit
                      );
                      setTotal(result?.pagination?.total || PageSetting.limit);
                      setpage(1);
                      setLoading(result?.loading || false);
                      return;
                    }}
                    onSelectCitiesChange={async (selected: any) => {
                      setLoading(true);

                      if (!selected) {
                        delete queryEntities.filter.city;
                      } else {
                        queryEntities.filter.city = `&filter[city][_eq]=${selected.value}&`;
                      }

                      searchEntities(
                        actor.collectionName,
                        queryEntities,
                        1,
                        PageSetting.limit
                      );
                      setTotal(result?.pagination?.total || PageSetting.limit);
                      setLoading(result?.loading || false);
                      return;
                    }}
                    onSelectRecognitionChange={async (selected: any) => {
                      setLoading(true);

                      if (!selected) {
                        delete queryEntities.filter.recognition;
                      } else {
                        queryEntities.filter.recognition = `&filter[recognized_min][_eq]=${selected.value}&`;
                      }

                      searchEntities(
                        actor.collectionName,
                        queryEntities,
                        1,
                        PageSetting.limit
                      );
                      setTotal(result?.pagination?.total || PageSetting.limit);
                      setLoading(result?.loading || false);
                      return;
                    }}
                    onClearActorType={async () => {
                      console.log("clear");
                      delete queryEntities.filter.actor;
                      delete queryEntities.filter.text;
                      searchEntities(
                        "all",
                        queryEntities,
                        1,
                        PageSetting.limit
                      );
                      setTotal(result?.pagination?.total || PageSetting.limit);
                      setLoading(result?.loading || false);
                      return;
                    }}
                    onClearCity={async () => {
                      setLoading(true);
                      delete queryEntities.filter.city;
                      searchEntities(
                        "all",
                        queryEntities,
                        1,
                        PageSetting.limit
                      );
                      setTotal(result?.pagination?.total || PageSetting.limit);
                      setLoading(result?.loading || false);
                    }}
                    onClearCommercialActivity={async () => {
                      setLoading(true);
                      delete queryEntities.filter.commercial_activity;
                      searchEntities(
                        "all",
                        queryEntities,
                        1,
                        PageSetting.limit
                      );
                      setTotal(result?.pagination?.total || PageSetting.limit);
                      setLoading(result?.loading || false);
                    }}
                    onClearMinCiencia={async () => {
                      setLoading(true);
                      delete queryEntities.filter.recognition;
                      searchEntities(
                        "all",
                        queryEntities,
                        1,
                        PageSetting.limit
                      );
                      setTotal(result?.pagination?.total || PageSetting.limit);
                      setLoading(result?.loading || false);
                    }}
                  />
                )}
              </div>
            </Header>
          </>
        )}
        <Content
          style={{
            padding: screens.xs ? 20 : 40,
            minHeight: 280,
            background: colorBgContainer,
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <Routes>
            <Route
              path="/capacities"
              element={
                <Capacities
                  data={{
                    isLoading: resultCapacities.loading,
                    capacity: capacity,
                    loading: loading || result.loading,
                    initialDataCapacities: resultCapacities.values,
                    pagination: resultCapacities.pagination,
                  }}
                />
              }
            />
            <Route
              path="/entities"
              element={
                <Entities
                  data={{
                    initialDataEntities: result.values,
                    loading: loading || result.loading,
                  }}
                />
              }
            />
            <Route path="/entities/:id" element={<EntityDetail />} />
            <Route path="/entities/:id" element={<EntityDetail />} />
            <Route path="/capacities/:id" element={<CapacityDetail />} />
            <Route path="/companies/:id" element={<CompaniesDetail />} />
            <Route path="/groups/:id" element={<GroupDetail />} />
            <Route path="/products/:id" element={<ProductDetail />} />
            <Route path="/searchers/:id" element={<SearcherDetail />} />
            <Route path="/universities/:id" element={<UniversitiesDetail />} />
            <Route path="/commons-entities/:id" element={<CommonsDetail />} />
          </Routes>
        </Content>
        {window.location.search.includes("actortype") ||
        location.pathname === "/entities" ? (
          <Row gutter={[8, 8]} style={{ width: "100%", textAlign: "center" }}>
            <Col xs={24} sm={12} md={8} lg={24}>
              {!loading && result.values?.length > 0 ? (
                <Pagination
                  showSizeChanger={false}
                  pageSize={PageSetting.limit}
                  className="conection-pagination"
                  defaultCurrent={1}
                  total={result.pagination?.total || PageSetting.limit}
                  onChange={async (page, pageSize) => {
                    const actorSelected: any = actorTypes.find(
                      (a: any) => a.collection_name === actorType
                    );

                    if (!actor || !actorSelected) {
                      searchEntities("all", queryEntities, page, pageSize);
                      return setpage(page);
                    }

                    queryEntities.filter.actor = `&filter[actor_type][id][_eq]=${
                      actor.value || actorSelected?.id
                    }`;

                    searchEntities(
                      actor.collectionName || actorSelected.collection_name,
                      queryEntities,
                      page,
                      pageSize
                    );
                    setTotal(result?.pagination?.total || PageSetting.limit);
                    setpage(page);
                    setLoading(false);
                  }}
                />
              ) : null}
            </Col>
          </Row>
        ) : null}
        <Row gutter={[8, 8]} style={{ width: "100%", textAlign: "center" }}>
          <Col xs={24} sm={12} md={8} lg={24}>
            {resultCapacities.values.length > 0 &&
            (location.pathname === "/capacities" ||
              window.location.search.includes("capacitytype")) ? (
              <Pagination
                showSizeChanger={false}
                pageSize={PageSetting.limit}
                className="conection-pagination"
                current={pageCapacity}
                defaultCurrent={PageSetting.page}
                total={resultCapacities.pagination?.total}
                onChange={async (page, pageSize) => {
                  const capacitySelected: any = capacities.find(
                    (a: any) => a.collection_name === capacityType
                  );

                  if (!capacity.value && !capacitySelected) {
                    searchCapacities("all", { filter: "" }, page, pageSize);
                    return setpageCapacity(page);
                  }

                  queryCapacities.filter.capacity = `&filter[capacity_type][id][_eq]=${
                    capacity.value || capacitySelected.id
                  }`;
                  searchCapacities(
                    capacity.collectionName || capacitySelected.collection_name,
                    queryCapacities,
                    page,
                    PageSetting.limit
                  );
                  setpageCapacity(page);
                }}
              />
            ) : null}
          </Col>
        </Row>
      </Layout>
      <Footer />
    </div>
  );
};

export default Dashboard;
